import React from 'react'
import LeadError from '../LeadError'
import { ReactComponent as Calendar } from 'assets/svg/icons/calendar.svg'
import { ReactComponent as CalendarRecurring } from 'assets/svg/icons/calendar-recurring.svg'

export default function LeadRecurrence(props) {
  const { data, setData, errors, setErrors } = props

  return (
    <div>
      <div className="p-8">
        <div className="flex text-gray-400">
          <Option
            icon={<Calendar className="h-6" />}
            text="One-Time Event"
            data-test-id="one-time"
            active={data.recurring === false}
            onClick={() => {
              setErrors(false)
              setData(prev => ({
                ...prev,
                recurring: false,
                occasion: undefined,
              }))
            }}
          />
          <Option
            icon={<CalendarRecurring className="h-6" />}
            text="Recurring Food Service"
            data-test-id="recurring"
            className="border-l-0"
            active={data.recurring === true}
            onClick={() => {
              setErrors(false)
              setData(prev => ({
                ...prev,
                recurring: true,
                occasion: undefined,
              }))
            }}
          />
        </div>
        {errors?.recurrence && (
          <LeadError message={errors.recurrence} className="text-center"/>
        )}
      </div>
    </div>
  )
}

function Option({ icon, text, active, className, ...rest }) {
  return (
    <div
      {...rest}
      className={[
        'cursor-pointer w-1/2 border border-gray-300 p-6 flex flex-col items-center',
        active && 'bg-white text-blue border-gray-400',
        className
      ]}
    >
      {icon}
      <div
        className={[
          'text-lg font-light',
          !active && 'text-gray-800',
        ]}
      >
        {text}
      </div>
    </div>
  )
}
